import React from "react";
import { Background, BackgroundVariant } from "reactflow";
import { useTheme } from "@mui/material/styles";

interface StandardBackgroundProps {
  id?: string;
  gap?: number;
  color?: string;
  variant?: BackgroundVariant;
}

/**
 * 🌌 StandardBackground
 * A reusable background component for React Flow.
 * Provides sensible defaults but allows overrides.
 */
const StandardBackground: React.FC<StandardBackgroundProps> = ({
  id = "1",
  gap = 20,
  color,
  variant = BackgroundVariant.Dots,
}) => {
  const theme = useTheme();

  return (
    <Background
      id={id}
      gap={gap}
      color={color || theme.custom.base.text.primary.dark}
      variant={variant}
    />
  );
};

export default StandardBackground;
